import { render, staticRenderFns } from "./AdminCrud.vue?vue&type=template&id=d21ebd20"
import script from "./AdminCrud.vue?vue&type=script&lang=js"
export * from "./AdminCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports